import { useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import "../../flaticon/flaticon.css";
import "./style.css";

const Subscribe = () => {
  useEffect(() => {
    if (window.hbspt) {
      window.hbspt.forms.create({
        portalId: "50197322",
        formId: "19ea01df-d56d-4735-8d29-ff70dd5b04d4",
        region: "na1",
        target: '#hubspotForm'
      });
    }
  }, []);

  return (
    <>
      <section className="subscribe-section section_100">
        <Container>
          <Row>
            <Col lg={12}>
              <div className="subscribe-box ">
                <div className="section-title">
                  <h2>
                  Suscríbete al <span>Newsletter</span>
                  </h2>
                  <p>Entérate primero de las últimas novedades</p>
                </div>
                <div id="hubspotForm"></div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default Subscribe;
